(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.runMultiCurrency();
    }
  };
  request.send();
};
// Reload the section as you edit theme settings
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-spl-banner-v3"] && !Shopify.designMode) return;
  try {
    
    

function CopyToClipBoard(element) {
    var $blankInput = $("<input>");
    $("body").append($blankInput);
    $blankInput.val($('.d-link-copy span').text()).select();
    document.execCommand("copy");
    $blankInput.remove();
  }

  $('.js-spl-copy').click(function(){
    CopyToClipBoard(this);
    $('.spl-clipboard').addClass('active');
    setTimeout(function(){                     
$('.spl-clipboard').removeClass('active');
    },1000);
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-spl-banner-v8"] && !Shopify.designMode) return;
  try {
    
$(".js-spl-toggle .js-spl-toggle-btn").on( "click", function() {
  $(this).closest(".js-spl-toggle").find('.js-spl-toggle-icon').toggleClass('spl-icon-arrow-down');
  $(this).closest(".js-spl-toggle").find('.js-spl-toggle-content').toggleClass('d-none');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-spl-grid-v2"] && !Shopify.designMode) return;
  try {
    
console.log();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-spl-tab"] && !Shopify.designMode) return;
  try {
    
  $(".js-spl-toggle .js-spl-toggle-btn").on( "click", function() {
    $(this).closest(".js-spl-toggle").find('.js-spl-toggle-icon').toggleClass('spl-icon-arrow-down');
    $(this).closest(".js-spl-toggle").find('.js-spl-toggle-content').toggleClass('d-none');
  });

  } catch(e) { console.error(e); }
})();
})();
